import { render, staticRenderFns } from "./edit-business-partner-step.vue?vue&type=template&id=7856bd12&"
import script from "./edit-business-partner-step.vue?vue&type=script&lang=js&"
export * from "./edit-business-partner-step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports